import store from '@/store'

var NUMERO_TWILIO_FAST = 'whatsapp:+5218123255321'
var DIAG_LOCAL_KEY = 'diag_sistema_registros'
var PUESTOS_PRUEBA = [11, 18, 19]

/** Misma lógica que App.vue → cambiarEscuela al iniciar sesión. */
var PLANTELES_INBI = [0, 1, 2, 3, 4, 5, 6, 21, 17, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34]
var IDERP_FORZAR_INBI = [1794]

var RUTAS = {
  TWILIO_FAST: 'twilio.chats',
  TWILIO_INBI: 'twilio.chatsMCG',
  CRM_FAST: 'twilio.chats.crmalumnos.fast',
  CRM_INBI: 'twilio.chats.crmalumnos',
}

/** 1 = INBI, 2 = FAST — usa getEscuela del store (fuente oficial de la plataforma). */
export function obtenerEscuelaUsuario (usuario) {
  try {
    var escuelaStore = store.getters['login/getEscuela']
    if (escuelaStore != null && escuelaStore !== '') {
      return Number(escuelaStore)
    }
  } catch (e) {}

  if (!usuario || usuario.id_plantel == null) return 1

  var idPlantel = Number(usuario.id_plantel)
  var iderp = Number(usuario.iderp)

  if (IDERP_FORZAR_INBI.includes(iderp)) return 1
  if (PLANTELES_INBI.includes(idPlantel) || idPlantel > 100) return 1
  return 2
}

export function esUsuarioFast (usuario) {
  return obtenerEscuelaUsuario(usuario) === 2
}

export function debeParticiparPrueba (usuario) {
  if (!usuario || usuario.idpuesto == null) return false
  return PUESTOS_PRUEBA.includes(Number(usuario.idpuesto))
}

export function resolverPruebaWhatsapp (usuario) {
  if (!debeParticiparPrueba(usuario)) return null

  var puesto = Number(usuario.idpuesto)
  var esFast = esUsuarioFast(usuario)

  // Puesto 11 (prueba admin): siempre Twilio Unificado
  if (puesto === 11) {
    return { endpoint: RUTAS.TWILIO_INBI, ruta: RUTAS.TWILIO_INBI, vista: 'Twilio Unificado' }
  }

  if (puesto === 18) {
    return esFast
      ? { endpoint: RUTAS.TWILIO_FAST, ruta: RUTAS.TWILIO_FAST, vista: 'Twilio FAST' }
      : { endpoint: RUTAS.TWILIO_INBI, ruta: RUTAS.TWILIO_INBI, vista: 'Twilio Unificado' }
  }

  if (puesto === 19) {
    return esFast
      ? { endpoint: RUTAS.CRM_FAST, ruta: RUTAS.CRM_FAST, vista: 'CRM Alumnos Fast' }
      : { endpoint: RUTAS.CRM_INBI, ruta: RUTAS.CRM_INBI, vista: 'CRM Alumnos' }
  }

  return null
}

export function buildPayloadPrueba (usuario, config) {
  var iderp = usuario.iderp
  var escuela = obtenerEscuelaUsuario(usuario)

  if (config.endpoint === RUTAS.TWILIO_FAST) {
    return {
      twilio: NUMERO_TWILIO_FAST,
      idusuario: iderp,
      escuela: escuela,
      offset: 0,
      limit: 100,
    }
  }

  if (config.endpoint === RUTAS.TWILIO_INBI) {
    // Puesto 11 siempre INBI unificado (escuela 1)
    var escuelaUnificado = Number(usuario.idpuesto) === 11 ? 1 : escuela
    return {
      idusuario: iderp,
      escuela: escuelaUnificado,
      offset: 0,
    }
  }

  return {
    idusuario: iderp,
    escuela: 1,
    idpuesto: usuario.idpuesto,
    idplantel: usuario.id_plantel,
  }
}

/** Reparte peticiones en ~6 s para no saturar el servidor cuando muchos reciben el socket a la vez. */
function delayEscalonadoPorUsuario (iderp) {
  var n = Math.abs(Number(iderp) || 0) % 30
  return n * 200
}

function esperarMs (ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms)
  })
}

export function capturarMetricasRed () {
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection
  var metricas = {
    online: navigator.onLine,
    type: conn && conn.effectiveType ? conn.effectiveType : null,
    rtt: conn && conn.rtt != null ? Math.round(conn.rtt) : null,
    speedMbps: conn && conn.downlink != null ? Number(conn.downlink) : null,
    pingMs: null,
  }

  try {
    var historial = JSON.parse(localStorage.getItem(DIAG_LOCAL_KEY) || '[]')
    if (historial.length && historial[0].red) {
      var red = historial[0].red
      var sem = historial[0].semaforo || {}
      if (red.speedMbps != null) metricas.speedMbps = red.speedMbps
      if (red.pingMs != null) metricas.pingMs = red.pingMs
      if (red.rtt != null) metricas.rtt = red.rtt
      if (red.type) metricas.type = red.type
      metricas.semaforo = {
        internet: sem.internet || null,
        latencia: sem.latencia || null,
      }
    }
  } catch (e) {}

  return metricas
}

var lotesEnProceso = new Set()
var STORAGE_PREFIX = 'prueba-wa-done-'

function claveLote (batchId, iderp) {
  return String(batchId) + ':' + String(iderp)
}

function yaProcesadoLote (batchId, iderp) {
  if (!batchId || iderp == null) return false
  var clave = claveLote(batchId, iderp)
  if (lotesEnProceso.has(clave)) return true
  try {
    return !!localStorage.getItem(STORAGE_PREFIX + clave)
  } catch (e) {
    return false
  }
}

function marcarLoteProcesado (batchId, iderp) {
  var clave = claveLote(batchId, iderp)
  lotesEnProceso.add(clave)
  try {
    localStorage.setItem(STORAGE_PREFIX + clave, String(Date.now()))
  } catch (e) {}
}

export async function ejecutarPruebaWhatsappRendimiento (http, usuario, batchId) {
  var config = resolverPruebaWhatsapp(usuario)
  if (!config) {
    return { omitido: true, razon: 'usuario_no_aplica' }
  }

  if (yaProcesadoLote(batchId, usuario.iderp)) {
    return { omitido: true, razon: 'duplicado' }
  }
  marcarLoteProcesado(batchId, usuario.iderp)

  var metricas = capturarMetricasRed()
  var payload = buildPayloadPrueba(usuario, config)
  var escuela = obtenerEscuelaUsuario(usuario)
  var delayMs = delayEscalonadoPorUsuario(usuario.iderp)

  // El cronómetro arranca después del escalonado: mide solo la petición HTTP
  await esperarMs(delayMs)

  var t0 = performance.now()
  var exito = false
  var errorMsg = null

  try {
    await http.post(config.endpoint, payload)
    exito = true
  } catch (error) {
    errorMsg =
      (error && error.response && error.response.data && error.response.data.message)
        ? error.response.data.message
        : (error && error.message)
          ? error.message
          : 'Error desconocido'
  }

  var tiempoMs = Math.round(performance.now() - t0)
  var esFast = escuela === 2

  var registro = {
    batchId: batchId,
    esFast: esFast,
    escuela: escuela,
    delayMs: delayMs,
    ruta: config.ruta,
    tiempoMs: tiempoMs,
    exito: exito,
    error: errorMsg,
    usuario: {
      iderp: usuario.iderp,
      nombre: usuario.nombre_completo || usuario.nombre_usuario || '',
      idpuesto: usuario.idpuesto,
    },
    red: {
      online: metricas.online,
      speedMbps: metricas.speedMbps,
      pingMs: metricas.pingMs,
      rttMs: metricas.rtt,
      type: metricas.type,
    },
    semaforo: metricas.semaforo || {},
    payload: payload,
  }

  try {
    await http.post('prueba-whatsapp-rendimiento.data', registro)
  } catch (e) {
    console.warn('[prueba-whatsapp-rendimiento] No se pudo guardar resultado', e)
  }

  return {
    omitido: false,
    ...registro,
    vista: config.vista,
  }
}

export const RUTAS_PRUEBA_WHATSAPP = [
  { value: RUTAS.TWILIO_FAST, text: 'Twilio FAST (twilio.chats)' },
  { value: RUTAS.TWILIO_INBI, text: 'Twilio Unificado (twilio.chatsMCG)' },
  { value: RUTAS.CRM_FAST, text: 'CRM Alumnos Fast (twilio.chats.crmalumnos.fast)' },
  { value: RUTAS.CRM_INBI, text: 'CRM Alumnos (twilio.chats.crmalumnos)' },
]

export const PUESTOS_OPCIONES = [
  { value: 11, text: 'Puesto 11 — Twilio Unificado (prueba)' },
  { value: 18, text: 'Puesto 18 — Twilio' },
  { value: 19, text: 'Puesto 19 — CRM Alumnos' },
]
